import script from "./LeagueView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueView.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueView.vue?vue&type=style&index=0&id=9dd66ec2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dd66ec2"]])

export default __exports__